import { supabase } from "@/integrations/supabase/client";

/**
 * Single entry point for writing admin audit entries rendered by the
 * Dashboard Activity Feed. Best-effort: logging must never block or fail
 * the action it describes.
 */
export async function logAdminActivity(
  action_type: string,
  description: string,
  metadata: Record<string, unknown> = {},
): Promise<void> {
  try {
    const { data } = await supabase.auth.getUser();
    const adminId = data.user?.id;
    if (!adminId) return;

    await supabase.from("admin_activity_logs").insert([
      { admin_id: adminId, action_type, description, metadata },
    ] as never);
  } catch {
    // Swallow — audit logging is non-critical.
  }
}
